import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './calculator-item.component.scss';
var CalculatorItem = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorItem, _super);
    function CalculatorItem(element) {
        return _super.call(this, element) || this;
    }
    CalculatorItem.prototype.init = function () { };
    CalculatorItem.prototype.bindEvents = function () { };
    return CalculatorItem;
}(Base));
export { CalculatorItem };



//////////////////
// WEBPACK FOOTER
// ./components/calculator-item/calculator-item.component.ts
// module id = 161
// module chunks = 0